import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

// ! component
import { IndexComponent } from './pages/index/index.component';
import { SignUpComponent } from './pages/sign/sign-up/sign-up.component';
import { SignInComponent } from './pages/sign/sign-in/sign-in.component';
import { MyAccountComponent } from './pages/member/my-account/my-account.component';
import { HumanRecruitComponent } from './pages/groupbreaks/human-recruit/human-recruit.component';
import { SecondTeamsFormComponent } from './pages/groupbreaks/second-teams-form/second-teams-form.component';
import { SignUpCallbackComponent } from './pages/sign-up-callback/sign-up-callback.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { GroupBreakListComponent } from './pages/groupbreaks/group-break-list/group-break-list.component';
import { GroupBreakDetailComponent } from './pages/groupbreaks/group-break-detail/group-break-detail.component';
import { MagneticCaseComponent } from './pages/merch/magnetic-case/magnetic-case.component';

const routes: Routes = [
	// ** web 2.0
	{ path: '', component: IndexComponent, data: { title: '首頁' } },
	{ path: 'signUp', component: SignUpComponent, data: { title: '會員註冊' } },
	{ path: 'signIn', component: SignInComponent, data: { title: '會員登入' } },
	{ path: 'myAccount', component: MyAccountComponent, data: { title: '我的帳戶' } },
	// ** 團拆商品列表頁 (從 Supabase 動態抓取上架中的商品)
	{ path: 'products', component: GroupBreakListComponent, data: { title: '商品列表' } },
	// ** 磁鐵殼 3D 展示原型（尚未串接庫存/售價，先給內部確認視覺方向）
	{ path: 'magneticCase', component: MagneticCaseComponent, data: { title: '鑑定卡磁鐵殼' } },
	// { path: 'teamsForm', component: HumanRecruitComponent, data: { title: '團拆表單' } },
	// { path: 'secondTeamsForm', component: SecondTeamsFormComponent, data: { title: '團拆表單' } },
	// { path: 'solutions', component: SolutionsComponent, data: { title: '解決方案' } },
	// { path: 'solutions/explore/:keyword', component: SolutionExploreComponent },
	// { path: 'solutions/explore', component: SolutionExploreComponent, data: { title: '各個領域的解決方案' } },
	// { path: 'success/:title', component: SuccessComponent },
	{ path: 'signUpCallback', component: SignUpCallbackComponent, data: { title: '驗證成功' } },
	{ path: 'page-not-found', component: PageNotFoundComponent, data: { title: '頁面不存在' } },
	// ** 團拆動態購買頁：依網址上的 productId 從 Supabase 動態載入商品資料 (如 /bigaunt/BAS-048)
	// 因為整個網站的 baseHref 本身就是 /bigaunt/，所以這裡註冊在根層級的 :productId 即可對應到 /bigaunt/BAS-048。
	// 必須放在所有固定路徑路由「之後」、萬用路由「之前」，確保不會擋掉其他既有路由。
	{ path: ':productId', component: GroupBreakDetailComponent, data: { title: '團拆購買' } },
	{ path: '**', redirectTo: 'page-not-found' },
];

@NgModule({
	imports: [
		CommonModule,
		BrowserModule,
		RouterModule.forRoot(routes, {
			scrollPositionRestoration: 'top',
		}),
	],
	exports: [],
})
export class AppRoutingModule {}
